import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Confirm } from 'semantic-ui-react'
import { MainBodyContent, StatusTag, CustomButton } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { 
  bgCompanyReportPath,
  bgCompanyReportEditPath
} from 'routes'
import { 
  getBGCompanyDetail,
  actionUpdateBGCompany,
  actionReturnBGCompany,
  validateReturn
} from 'ducks/bgCompany'
import { getBankOwners } from 'ducks/bankGuarantee'
import { statusColor } from '../AttributeData'
import { getVendors, getCompanies, getCustomers } from 'ducks/options'
import { validateApproveField } from '../helper'
import BankGuaranteeInformation from '../Shareds/BankGuaranteeInformation'
import GeneralInformation from '../Shareds/GeneralInformation'
import ContactComponent from '../Shareds/Contact'
import AttachmentComponent from '../Shareds/Attachment'
import CommentComponent from '../Shareds/Comment'
import BankGuaranteeRelated from '../Shareds/BankGuaranteeRelated'
import ReturnInformation from '../Shareds/ReturnInformation'
import Approve from '../Shareds/Approve'
import { TitleCont } from './styled'

const DetailBankGuaranteeCompany = (props) => {

  const { 
    valueForm, 
    history,
    isDetail = true
  } = props

  const [showConfirm, setShowConfirm] = React.useState(false)
  const [enableUpdate, setEnableUpdate] = React.useState(false)
  const [enableReturnBG, setEnableReturnBG] = React.useState(false)

  React.useEffect(()=>{ // check to edit mode
    if(valueForm.id){
      if([0].indexOf(valueForm.status)>=0&&valueForm.isValid){
        history.replace(bgCompanyReportEditPath(valueForm.id))
      }
    }
  },[valueForm.id])

  React.useEffect(() => {
    props.getBGCompanyDetail(props.match.params.id, props.history)
    props.getVendors()
    props.getCompanies()
    props.getBankOwners()
    props.getCustomers()
  }, [])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      setShowConfirm(true)
    })
  } 

  const confirmSubmit = () =>{
    setShowConfirm(false)
    if(enableUpdate){
      props.actionUpdateBGCompany(valueForm, history)
    }
    if(enableReturnBG){
      props.actionReturnBGCompany(valueForm, history)
    }
  }

  const setSpecialButton = () => {
    if([100,200,500].indexOf(valueForm.status)>=0&&valueForm.isValid&&!enableUpdate&&!enableReturnBG){
      return (
        <React.Fragment>
          <div style={{ display: 'flex' }}>
            <CustomButton
              icon='redo'
              btnColor='blue'
              title='Return BG'
              onClick={()=>{
                props.change('isActionReturn',true)
                setEnableReturnBG(true)
                document.getElementById('returnbg').scrollIntoView()
                props.validateReturn(valueForm.id)
              }}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <CustomButton
              icon={enableUpdate?'close':"edit"}
              btnColor={enableUpdate?'red':"green"}
              title={enableUpdate?'Close':"Edit"}
              onClick={()=>{
                document.getElementById('editbg').scrollIntoView()
                setEnableUpdate(true)
              }}
            />
          </div>
        </React.Fragment>
      )
    }else{
      return null
    }
  }

  const getConfirmMessage = () =>{
    if(enableUpdate){
      return 'Are you sure?'
    }else {
      if(props.validateReturnData.conflict){
        return props.validateReturnData.message
      }else{
        return 'Are you sure?'
      }
    }    
  }

  const showRef = () =>{
    return valueForm.referenceBgCompanyRequestId||
          valueForm.referenceBgCompanyOriginalId||
          valueForm.referenceBgCompanyExtendId||
          (valueForm.extendedLists&&valueForm.extendedLists.length>0)
  }

  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Bank Guarantee Company- ${valueForm.documentNumber||'Detail'}`}
          <StatusTag status={valueForm.status} statusName={valueForm.statusName} style={{background:statusColor[`${valueForm.status}`],marginLeft: '10px'}}/>
        </React.Fragment>
      }
      accessoriesHeader={setSpecialButton()}
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'BG Company', link: true, onClick: () => props.history.push(bgCompanyReportPath) },
              { key: 'BGDetail', content: 'Detail', active: true }
            ]
          }
        />
      }
    >
      <div style={{height:'1rem'}}/>
      <div style={{display:'flex'}}>
        <TitleCont>Document Type : {valueForm.documentType||'-'}</TitleCont>
      </div>
      <GeneralInformation isDetail={isDetail}/>
      {showRef()?
      <BankGuaranteeRelated/>:null}
      <BankGuaranteeInformation/>
      <span id='returnbg'/>
      {enableReturnBG?
      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <ReturnInformation
          onCancelClick={()=>{
            props.change('returnDate',null)
            props.change('isActionReturn',false)
            setEnableReturnBG(false)
          }}
        />
      </form>:null}
      <ContactComponent/>
      <AttachmentComponent isDetail={!enableUpdate} isEdit={enableUpdate}/>
      <span id='editbg'/>
      {enableUpdate?
      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <Approve
          onCancelClick={()=>{
            setEnableUpdate(false)
          }}
        />
      </form>:null}
      <CommentComponent/>
      <Confirm
        size='mini'
        open={showConfirm}
        content={getConfirmMessage()}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => confirmSubmit()}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  const valueForm = getFormValues('formBGCompany')(state) || {}

  return ({
    valueForm,
    username,
    validateReturnData:state.bgCompany.validateReturn,
    initialValues: {
      requesterUser: username,
      attachments: [],
      contacts: [],
      comments: [],
      isContactValid: true,
      ...state.bgCompany.detail.data
    },
  })
}

const mapDispatchToProps = {
  getBGCompanyDetail,
  getVendors, 
  getCompanies,
  getBankOwners,
  actionUpdateBGCompany,
  actionReturnBGCompany,
  validateReturn, 
  getCustomers
}

const validate = (values) => {
  let errors = validateApproveField(values)
  return errors
}

const ContForm = reduxForm({
  form: 'formBGCompany',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate
})(DetailBankGuaranteeCompany)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
